import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import { widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    root: {
        flex: 1,
        justifyContent: 'flex-end',
    },
    phoneRoot: {
        alignItems: 'center',
    },
    phoneRow1: {
        width: widthPercentageToDP(80),
        height: 32,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        borderRadius: 32,
        marginBottom: 16,
    },
    phoneRow2: {
        width: widthPercentageToDP(320),
        height: 24,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        borderRadius: 24,
        marginBottom: 24,
    },
    phoneRow3: {
        width: widthPercentageToDP(219),
        height: 20,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        borderRadius: 20,
        marginBottom: 12,
    },
    phoneRow4: {
        width: widthPercentageToDP(256),
        height: 12,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        borderRadius: 12,
        marginBottom: 28,
    },
    phoneRow5: {
        width: widthPercentageToDP(328),
        height: 48,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        borderRadius: 6,
        marginBottom: 16,
    },
    tabletRoot: {
        paddingLeft: widthPercentageToDP(44),
    },
    tabletRow1: {
        width: widthPercentageToDP(80),
        height: 32,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        borderRadius: 32,
        marginBottom: 16,
    },
    tabletRow2: {
        width: widthPercentageToDP(400),
        height: 24,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        borderRadius: 24,
        marginBottom: 24,
    },
    tabletRow3: {
        width: widthPercentageToDP(220),
        height: 20,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        borderRadius: 20,
        marginBottom: 12,
    },
    tabletRow4: {
        width: widthPercentageToDP(256),
        height: 12,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        borderRadius: 12,
        marginBottom: 24,
    },
    tabletRow5: {
        width: widthPercentageToDP(120),
        height: 48,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        borderRadius: 6,
        marginBottom: 16,
    },
    webRoot: {
        paddingLeft: widthPercentageToDP(72),
        paddingBottom: 24,
    },
    paginatedDot: { height: 8 },
});

export default styles;
